import { useSelector } from 'react-redux';

export const useSidebarPermissions = () => {
  const isProfileComplete = useSelector((state) => state.auth.isProfileComplete);
  const hasAIJobImpact = useSelector((state) => state.user.hasAIJobImpact);
  const targetJob = useSelector((state) => state.user.targetJob);
  const userId = useSelector((state) => state.auth.id);
  const userType = useSelector((state) => state.auth.type);

  const isAlwaysAccessible = (itemName, itemLink) => {
    const profileItems = ['Profile', 'Profile Settings'];
    const helpItems = ['FAQ', 'Help us Improve', 'Update Subscription', 'Support'];
    
    return profileItems.includes(itemName) || 
           helpItems.includes(itemName) ||
           itemLink === '/dashboard/profile' ||
           itemLink?.includes('/dashboard/help-and-support');
  };

  const isCategoryDisabled = (categoryName) => {
    if (userType !== "user") return false;
    
    if (isProfileComplete && hasAIJobImpact && targetJob) return false;
    
    // Always accessible categories
    if (['Profile', 'Profile Settings', 'Help & Support'].includes(categoryName)) return false;
    
    // Disable based on missing requirements
    if (!hasAIJobImpact && ['Career Discovery', 'Skills and Learning'].includes(categoryName)) return true;
    if (!targetJob && categoryName === 'Skills and Learning') return true;
    if (!isProfileComplete) return true;
    
    return false;
  };

  // Check if submenu item should be disabled
  const isSubmenuItemDisabled = (itemName, itemLink) => {
    if (isAlwaysAccessible(itemName, itemLink)) return false;
    
    // Only apply locking logic to mentees (type: "user")
    if (userType !== "user") return false;
    
    if (itemName === 'AI Literacy Assessment') {
      return !hasAIJobImpact || !targetJob;
    }
    
    return !isProfileComplete;
  };

  const getTooltipMessage = (itemName, categoryName) => {
    if (userType !== "user") return "";
    
    if (!isProfileComplete) return "Please complete your profile first";
    if (!hasAIJobImpact && ['Career Discovery', 'Skills and Learning'].includes(categoryName)) {
      return "Complete AI Job Impact Assessment first";
    }
    if (!targetJob && categoryName === 'Skills and Learning') {
      return "Select a target career first";
    }
    if (itemName === 'AI Literacy Assessment' && !hasAIJobImpact) {
      return "Complete AI Job Impact Assessment first";
    }
    if (itemName === 'AI Literacy Assessment' && !targetJob) {
      return "Select a target career first";
    }
    return "Please complete your profile first";
  };

  return {
    isCategoryDisabled,
    isSubmenuItemDisabled,
    getTooltipMessage,
    isProfileComplete,
    hasAIJobImpact,
    targetJob
  };
};
